import Asterisk from "./Asterisk";

export default Asterisk;